import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { RobotOutlined } from "@ant-design/icons";
import { Result } from "antd";
import { Helmet } from "react-helmet";
import { useTranslation } from "../../../others/i18n.js";
const RouteRealCommerceContent = ()=>{
    const { t } = useTranslation("rc");
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                children: /*#__PURE__*/ _jsx("title", {
                    children: t("Real Commerce")
                })
            }),
            /*#__PURE__*/ _jsx(Result, {
                icon: /*#__PURE__*/ _jsx(RobotOutlined, {}),
                title: t("Not yet implemented")
            })
        ]
    });
};
export { RouteRealCommerceContent };
